const navigation = [
  {
    text: 'Home',
    icon: 'welcome',
    path: '/',
    exact: true,
  },
  {
    text: 'Contacts',
    icon: 'contacts',
    path: '/contacts',
    permission: 'contacts',
  },
  {
    text: 'Groups',
    icon: 'groups',
    path: '/groups',
    permission: 'contacts',
    feature: 'groups',
  },
  {
    text: 'Conversations',
    icon: 'conversations',
    path: '/conversations',
    permission: 'conversations',
    feature: 'conversations',
  },
  {
    text: 'Campaigns',
    icon: 'campaigns',
    path: '/campaigns',
    permission: 'campaigns',
    feature: 'campaigns',
  },
  {
    text: 'Lessons',
    icon: 'lessons',
    path: '/lessons',
    permission: 'lessons',
    feature: 'lessons',
  },
  {
    text: 'Automations',
    icon: 'automations',
    path: '/automations',
    permission: 'automations',
    feature: 'automations',
  },
  {
    text: 'Reports',
    icon: 'reports',
    path: '/reports',
    feature: 'reports',
  },
];

// hidden in more bucket
const secondaryNavigation = [
  {
    text: 'Tasks',
    icon: 'tasks',
    path: '/tasks',
    feature: 'tasks',
  },
  {
    text: 'Files',
    icon: 'collections',
    fontIcon: true,
    path: '/files',
  },
  {
    text: 'Snippets',
    icon: 'snippets',
    path: '/snippets',
    feature: 'snippets',
  },
  {
    text: 'Custom Objects',
    icon: 'data_object',
    fontIcon: true,
    path: '/custom-objects',
    permission: 'custom_objects',
    feature: 'custom_objects',
    roles: ['admin'],
  },
];

const resources = [
  {
    text: 'Help Docs',
    icon: 'help',
    href: 'https://conveyour.com/help',
  },
  {
    text: 'Video Gallery',
    icon: 'videos',
    href: 'https://conveyour.com/videos',
  },
];

export { navigation, secondaryNavigation, resources };
